// extracted by mini-css-extract-plugin
module.exports = {"form":"Form_form__nG53R"};